// extracted by mini-css-extract-plugin
export default {"select":"TicketStatusSelect_select__2UEjr"};